import metricsWorker from './worker';
import WebWorker from './helpers/web-worker';

const worker = new WebWorker(metricsWorker);

window.document.addEventListener('page:load', e => worker.postMessage({ type: 'page:load', data: e.detail }));
